import React, { useEffect, useRef, useState } from "react";
import "./Onboard.scss";

import { FaChevronRight } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { updateUserNewStatus } from "../../api/userManagement";
import {
  updateOpenOnboard,
  updateUserStatus,
} from "../../redux/features/user-slice";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";

const OnboardContents = [
  {
    img: "/images/onboard/1.svg",
    title: "Your Business, Simplified.",
    message: "Start managing, growing and thriving with ease.",
  },
  {
    img: "/images/onboard/2.svg",
    title: "Save Time, Achieve More.",
    message: "Automate processes and focus on what matters more.",
  },
  {
    img: "/images/onboard/3.svg",
    title: "Data-Driven Decisions Made Simple.",
    message: "Access real-time analyitcs and make smarter business choices.",
  },
  {
    img: "/images/onboard/4.svg",
    title: "You're All Set!",
    message: "Start exploring or take a quick tour to learn more.",
  },
];

const Onboard = () => {
  const navigate = useNavigate();
  const { id: user_id, open_onboard } = useSelector(
    (state) => state.userReducer.value
  );

  const dispatch = useDispatch();
  const nextButtonRef = useRef(null);

  const nextRef = useRef(null);
  const previousRef = useRef(null);

  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    const totalTabs = OnboardContents.length;
    const progressPercentage = ((selectedTab + 1) / totalTabs) * 100;
    if (nextButtonRef.current) {
      nextButtonRef.current.style.setProperty(
        "--progress",
        `${progressPercentage}%`
      );
    }
  }, [selectedTab]);

  const handleFinishOnboard = () => {
    navigate(ROUTES.home.path);
    dispatch(updateOpenOnboard({ open_onboard: false }));
    dispatch(updateUserStatus({ is_new: false }));

    updateUserNewStatus(user_id)
      .then((res) => {})
      .catch((err) => {});
  };

  const handleNext = () => {
    if (selectedTab < OnboardContents.length - 1) {
      const temp = selectedTab + 1;
      setSelectedTab(temp);

      //   if (nextRef.current) {
      //     nextRef.current.scrollIntoView({
      //       block: "nearest",
      //       behavior: "smooth",
      //       inline: "end",
      //     });
      //   }
    } else {
      handleFinishOnboard();
    }
  };

  const handlePrevious = () => {
    if (selectedTab > 0) {
      const temp = selectedTab - 1;
      setSelectedTab(temp);

      //   if (previousRef.current) {
      //     previousRef.current.scrollIntoView({
      //       block: "nearest",
      //       behavior: "smooth",
      //       inline: "end",
      //     });
      //   }
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open_onboard) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open_onboard, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`on-board-page ${isVisible ? "active" : ""}`}>
      <div className="slider-contents">
        {/* {OnboardContents.map((el, i) => {
          return (
            <div
              className="slide-item"
              key={i}
              ref={
                i === selectedTab - 1
                  ? previousRef
                  : i === selectedTab + 1
                  ? nextRef
                  : null
              }
            >
              <img src={el.img} alt="" aria-label="Slide" />
              <div className="contents">
                <p className="title">{el.title}</p>
                <p>{el.message}</p>
              </div>
            </div>
          );
        })} */}
        <div className="slide-item">
          <img
            src={OnboardContents[selectedTab].img}
            alt="" aria-label={OnboardContents[selectedTab].title}
          />
          <div className="contents">
            <p className="title">{OnboardContents[selectedTab].title}</p>
            <p>{OnboardContents[selectedTab].message}</p>
          </div>
        </div>
      </div>
      <div className="next-button" ref={nextButtonRef} onClick={handleNext}>
        <div className="progress-ring"></div>
        <div className="svg">
          <FaChevronRight />
        </div>
      </div>

      <p className="skip-button" onClick={handleFinishOnboard}>
        Skip
      </p>

      <div
        className={`back-button ${selectedTab > 0 ? "active" : ""}`}
        onClick={handlePrevious}
      >
        <FaChevronRight />
      </div>
    </div>
  );
};

export default Onboard;
